import React, { useEffect, useState } from "react";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { getRideRecords } from "~src/service/bike_ride";
import { createSearchParams } from "react-router-dom";
import styles from './index.module.less';
import { weightFormatter } from "~src/utils/tool";
import * as echarts from 'echarts';
import { StatisticsType } from "~src/service/bike_ride/bike_ride";

export default React.memo(() => {
  useDocumentTitle("骑行减碳");
  const [data, setData] = useState<{ title: string, miniTitle?: string,value: number, unit: string }[]>([]);

  const [weekData, setWeekData] = useState<{ title: string,miniTitle?: string, value: number, unit: string }[]>([]);

  useEffect(() => {
    const data = createSearchParams(window.location.search.split("?")[1] || "") || {};
    if (data.get("token") !== localStorage.getItem("mio-token")) {
      localStorage.setItem("mio-token", data.get("token") || "")
    }
    getRecords();
  }, [])

  const getRecords = async () => {
    const {
      currentDayDistance,
      currentDayMinusCarbon,
      totalDistance,
      totalMinusCarbon,
      latelyCarbon,
      averageWeekCarbon,
      statistics
    } = await getRideRecords();
    setData([{
      title: "今日已骑行",
      value: currentDayDistance,
      unit: "公里"
    },
    {
      title: "减少CO",
      miniTitle: "2",
      value: weightFormatter(currentDayMinusCarbon)[0] as number,
      unit: weightFormatter(currentDayMinusCarbon)[1] as string,
    },
    {
      title: "累计骑行",
      value: totalDistance,
      unit: "公里"
    },
    {
      title: "累计减少CO",
      miniTitle: "2",
      value: weightFormatter(totalMinusCarbon)[0] as number,
      unit: weightFormatter(totalMinusCarbon)[1] as string,
    }]);
    setWeekData([
      {
        title: "近7天减少CO",
        miniTitle: "2",
        value: weightFormatter(latelyCarbon)[0] as number,
        unit: weightFormatter(latelyCarbon)[1] as string,
      },
      {
        title: "平均每周减少CO",
        miniTitle: "2",
        value: weightFormatter(averageWeekCarbon)[0] as number,
        unit: weightFormatter(averageWeekCarbon)[1] as string,
      },
    ]);
    initCharts(statistics);
  }

  const initCharts = (echartsData: StatisticsType[]) => {
    if (document.getElementById('charts')) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('charts') as HTMLElement);

      // 指定图表的配置项和数据
      var option = {
        grid: {
          x: 34,
          y: 50,
          x2: 34,
          y2: 35
        },
        legend: {
          show: false
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: "axis", // 坐标轴触发
          padding: [0, 0, 0, 0],
          backgroundColor: "rgba(255,255,255,0)",
          alwaysShowContent: false,
          borderColor: "#f00",
          borderWidth: 0,
          borderRadius: 8,
          shadowBlur: 0,
          shadowColor: 'rgba(0, 0, 0, 0)',
          formatter: function (params: any[]) {
            let html = `<div style="height:auto;width: auto;">
                ${params
                .map(
                  (
                    item
                  ) => {
                    let [value, unit] = weightFormatter(item.value);
                    return `<div>
                      <div style="min-width: 40px;text-align: center;background-color: #23D55A;border-radius: 8px;padding: 2px 6px;height: 26px;font-size: 20px;font-family: DINPro-Bold, DINPro;color: #FFFFFF;line-height: 26px;">
                      <span style="font-weight: bold;">${value}</span><span style="font-size: 12px;margin-left: 2px;">${unit}</span>
                      </div>
                      <div style="width: 0px;height: 0px;transform-origin: center;border: 8px solid;border-color: #23D55A transparent transparent transparent;transform: translate(-50%,0);;margin-left:50%;"></div>
                      </div>`
                  }
                )
                .join("")}
              </div>`;
            return html;
          },
          axisPointer: {
            type: "none",    // 十字线，表示启用两个正交的轴，还可为'line'，'none'，'shadow'
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: echartsData.map(({ weekOf }) => (weekOf)),
          splitLine: {
            show: true,
            lineStyle: {
              color: "#23D65A",
              width: 1,
              type: "dashed"
            },
            inactiveColor: "#23D65A",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#23D65A',  //更改坐标轴文字颜色
              fontSize: 12      //更改坐标轴文字大小
            }
          },
        },
        yAxis: {
          type: 'value',
          show: false,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: echartsData.map(({ minusCarbon }) => (Number(minusCarbon))),
            type: 'line',
            showSymbol: false,
            smooth: true,
            lineStyle: {
              color: "#23D65A",
              width: 4
            },
            emphasis: {
              scale: 2,
              itemStyle: {
                color: "#23D65A",
                borderColor: "rgba(35, 211, 89, 0.20)",
                borderWidth: 6,
                opacity: 1
              },
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  }

  return (<div className={styles.result}>
    <div className={styles.data}>
      <div className={styles.block}>
        {data.map(({
          title,
          miniTitle,
          value,
          unit
        }) => (<div className={styles.item} key={title}>
          <div className={styles.title}>{title}<span className={styles.mini}>{miniTitle}</span></div>
          <div className={styles.value}>{value}<div className={styles.unit}>{unit}</div></div>
        </div>))}
      </div>
    </div>
    <div className={styles.charts}>
      <div className={styles.block}>
        {weekData.map(({
          title,
          miniTitle,
          value,
          unit
        }) => (<div className={styles.item} key={title}>
          <div className={styles.title}>{title}<span className={styles.mini}>{miniTitle}</span></div>
          <div className={styles.value}>{value}<div className={styles.unit}>{unit}</div></div>
        </div>))}
      </div>
      <div className={styles.echarts} id="charts"></div>
    </div>
  </div>)
})
